import PropTypes from "prop-types";
import React from "react";
import {Link} from "react-router-dom";
import InputField from "components/FormElements/InputField";
import { Field } from "redux-form";
import Button from "react-md/lib/Buttons/Button";
import logo from "static/images/logo.png";

const ForgotPassword = ({
  forgotPassword,
  // provided by redux-form
  handleSubmit,
  invalid,
  pristine,
  submitting
}) => {
  return (
    <div className="md-grid md-cell login-wrapper">
      <div className="login-form">
        <img src={logo} alt="logo.png" className="mueller-logo"/>
        <h3 className="mueller-title" data-test="title">Access Mueller Reports</h3>
          <form onSubmit={handleSubmit(forgotPassword)}>
            <Field
              id="username"
              name="username"
              component={InputField}
              type="text"
              hintText="Mueller Username"
              dataTest="username"
            />
            <Button
              primary
              raised
              type="submit"
              children="REQUEST NEW PASSWORD"
              className="full-width m-t-10"
              disabled={invalid || pristine || submitting}
              data-test="forgot-password"
            />
            <Link to="/login" className="link" data-test="back-to-login">
              BACK TO LOGIN
            </Link>
          </form>
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default ForgotPassword;
